import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React, { useContext, useEffect, useRef } from "react";

export default function PieChart({ data, title, dashboard }) {
  let dados;
  if (data) {
    dados = data;
  } else {
    dados = [];
  }

  dados = dados.filter(function (el) {
    return el != null;
  });
  dados = dados.filter((el) => el.name != "TOTAL");

  const chartRef = useRef(null);

  let labels = dados.map((row) => row.name);
  let rows = dados.map((row) => row.pct);
  rows.map((item, index) => {
    rows[index] = item.replace("%", "");
  });

  const options = {
    layout: {
      padding: {
        top: 20,
      },
    },
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      datalabels: {
        // display: false,
        labels: {
          title: {
            color: function (context) {
              return "black"; // context.dataset.backgroundColor[context.dataIndex]
            },
            // backgroundColor: "#ffffff99",
            backgroundColor: "#e4e4e4",
            // color: "black",
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 1400 ? 10 : 12,
                weight: "bold"
              };
            },
          },
        },
        formatter: function (value, context) {
          return (Math.round(value * 10) / 10).toFixed(1) + "%";
        },
        anchor: "end",
        clamping: true,
        // align: "center",
        // offset: function (context) {
        //   return 18 * (context.dataIndex + 1)
        // },
      },
      title: {
        display: false,
        text: title,
        font: {
          size: 100,
        },
      },
      legend: {
        display: true,
        boxWidth: 6,
        position: "bottom",
        fullSize: true,
        font: 10,
        labels: {
          boxWidth: 9,
          boxHeight: 9,
          padding: 10,
          color: "#000000",
          font: {
            size: 9,
            weight: "bold",
          },
        },
      },
    },
  };
  const config = {
    responsive: true,
    maintainAspectRatio: true,
    type: "pie",
    data: {
      labels: labels,
      datasets: [
        {
          data: rows,
          lable: "teste",
          backgroundColor: [
            "#2c4992",
            "#e2746f",
            "#00a7e1",
            "#ec1c24",
            "#9e5fdf",
            "#ED7D31",
            "#A5A5A5",
            "#FFC000",
            "#70AD47",
            "#9E480E",
            "#997300",
            "#acc245",
            "#980048",
            "#15dbab",
            "#FF69B4",
          ],
        },
      ],
    },
    options: {
      layout: {
        padding: 2,
      },
      plugins: {
        customCanvasBackgroundColor: {
          color: "red",
        },
      },
    },
  };

  function clickHandler() {
    const link = document.createElement("a");
    link.download = "chart.jpeg";
    link.href = chartRef.current.toBase64Image("image/jpeg", 1);
    link.click();
  }

  return (
    <>
      <Pie ref={chartRef} data={config.data} options={options} />
    </>
  );
}
